import Canvastoimg from "wtc-canvastoimg";

Vue.component("footernew", {
  props: {
    footer_card_info: Object,
  },
  template: `
  <div>
		<div>
			<div class="article-from">
				<div class="article-author">
					<label v-if="wxAccountname">来源：<span>{{wxAccountname}}</span></lable>
				</div>
				<div class="article-statement" @click="handleStatement">
					<img src="https://assets.rurushishi.com/yq-rs-h5/t1/new-usercard/icon-attention.png">
					<label>免责声明</label>
					<img v-if="isShowStatement" src="https://assets.rurushishi.com/yq-rs-h5/t1/new-usercard/icon-down.png">
					<img v-else src="https://assets.rurushishi.com/yq-rs-h5/t1/new-usercard/icon-up.png">
				</div>
			</div>
			<div class="article-statement-text" v-if="isShowStatement">该文章由<span v-if="wxAccountname">{{wxAccountname + '的'}}</span>用户自主上传，文字版权归原作者所有，如果您发现内容存在版权问题，请点击<label @click="handleComplaint"> 投诉 </label>提交您的投诉内容，我们将及时处理。谢谢！</div>
			<div class="article-new-operation">
				<div class="article-operation-item" v-if="!isCollect" @click="handleCollect">
					<img src="https://assets.rurushishi.com/yq-rs-h5/t1/new-usercard/icon-like.png">
					<span>收藏</span>
				</div>
				<div class="article-operation-item article-operation-click" v-else @click="handleCollect">
					<img src="https://assets.rurushishi.com/yq-rs-h5/t1/new-usercard/icon-liked.png">
					<span>收藏</span>
				</div>
				<div class="article-operation-item" v-if="!isSupport" @click="isSupport=!isSupport">
					<img src="https://assets.rurushishi.com/yq-rs-h5/t1/new-usercard/icon-support.png">
					<span>好文章</span>
				</div>
				<div class="article-operation-item article-operation-click" v-else @click="isSupport=!isSupport">
					<img src="https://assets.rurushishi.com/yq-rs-h5/t1/new-usercard/icon-supported.png">
					<span>好文章</span>
				</div>
				<div class="article-operation-item" @click="handleComplaint">
					<img src="https://assets.rurushishi.com/yq-rs-h5/t1/new-usercard/icon-attention.png">
					<span>投诉</span>
				</div>
			</div>
		</div>
		<div class="usercard-article-container hide" v-if="isShowCard && cardInfo && cardInfo.ui">
			<div v-bind:class="[isDarker ? 'usercard-article-box darker' : 'usercard-article-box light']" v-bind:style="{ backgroundColor: cardInfo && cardInfo.ui_cardcolor ? cardInfo.ui_cardcolor : '#D6BF8E' }">
				<div class="usercard-head">
					<img :src="cardInfo.ui.headimg">
				</div>
				<div class="usercard-info">
					<div class="usercard-name">{{cardInfo.ui.name}}</div>
					<div class="usercard-company">
						<span v-if="cardInfo.ui && cardInfo.ui.company">{{cardInfo.ui.company}}</span>
					</div>
				</div>
				<div class="usercard-nav-box">
					<div class="usercard-nav" v-for="(item,index) in newNavData" :key="index" @click="clickItem(item)">
					  <img class="nav-icon" v-if="isDarker" :src="item.ico_darker">
					  <img class="nav-icon" v-else :src="item.ico_light">
					  <label>{{item.name}}</label>
					</div>
				</div>
			</div>
		</div>
		<div class="recommend-title-container" v-if="showRecommend && recommendList && recommendList.length">
			<div class="recommend-title">相关推荐</div>
		</div>
		<div class="recommend-container" v-if="showRecommend && recommendList && recommendList.length">
			<div class="recommend-box" v-for="(item,index) in recommendList" :key="index" @click="handleRecommend(item)">
				<div class="recommend-left">
					<div class="recommend-name">
					  <span>{{item.title}}</span>
					</div>
					<div class="recommend-info">
						<div>{{item.pagesharecount}} 转发</div>
					</div>
				</div>
				<div class="recommend-right">
					<img :src="item.wxsmallpic">
				</div>
			</div>
		</div>
		<div class="share_mask" v-if="showComplaint">
			<div class="mask_box" @click="handleCancel"></div>
			<div class="complaint-container">
				<div class="complaint-title">投诉原因</div>
				<div class="complaint-box">
					<div v-for="(item,index) in complaintList" :key="index" @click="handleSelect(item)">{{item}}</div>
				</div>
				<div class="complaint-cancel" @click="handleCancel">取消</div>
			</div>
		</div>
		<div class="complaint-toast-container" v-if="showComplaintToast">
			<div class="complaint-toast-box">
				<div class="toast-icon">
					<img src="https://assets.rurushishi.com/yq-rs-h5/t1/new-usercard/icon-ok.png">
				</div>
				<div class="toast-text">我们将核实反馈信息 尽快处理您的投诉！</div>
			</div>
		</div>
  </div>
  `,
  data() {
    return {
      isShowUserCard: false,
      isShowStatement: false, // 免责声明
      recommendList: null, // 推荐文章列表
      wxAccountname: null,
      isSupport: false,
      showComplaint: false, // 投诉
      isCollect: false, // 收藏
      showComplaintToast: false, // 投诉弹窗
      step: null,
			complaintList: [
				'文章内容太差',
				'文章包含（虚假抽奖/假红包信息）',
				'文章包含侵权或违法信息',
				'文章可能包含谣言信息',
				'文章包含诱导分享/关注的内容',				
			]
    };
  },
  computed: {
    isDarker() {
      if (this.cardInfo?.ui_cardcolor == "#D6BF8E" || this.cardInfo?.ui_cardcolor == "#D7D7D8") {
        return true;
      } else {
        return false;
      }
    },
    cardConfig() {
      return this.footer_card_info?.cardConfig || {};
    },
    cardInfo() {
      return this.footer_card_info?.cardInfo || {};
    },
    newNavData() {
      return this.footer_card_info?.newNavData || {};
    },
    isShowCard() {
      if (this.footer_card_info?.cardInfo?.ui_downshow) {
        return true;
      } else {
        return false;
      }
    },
		showRecommend() {
		  if (this.footer_card_info?.cardInfo?.ui_showrecommend) {
		    return true;
		  } else {
		    return false;
		  }
		}
  },
  watch: {},
  methods: {
    handleStatement() {
      this.isShowStatement = !this.isShowStatement;
    },
    clickItem(item) {
      console.log(item.click);
      this.$emit("handle-nav", item.click);
    },
    initRecommendList() {
      comreq.getRecommendList(myPageData.PageId).then((res) => {
        console.log("RecommendList", res);
        if (res.code == 0 && res.data?.length) {
          this.recommendList = res.data;
        }
      });
    },
		/**
		 * 从url上获取参数
		 */
		getParamFromUrl(url) {
		  let tmpObj = {};
		  let tmpArr = url.split("?");
		  if (tmpArr.length == 2) {
		    let urlParam = tmpArr[1];
		    let tmpArr1 = urlParam.split('&');
		    tmpArr1 = tmpArr1.map(function (e) {
		      tmpObj[e.split('=')[0]] = e.split('=')[1];
		    })
		  }
		  return tmpObj;
		},
		/**
		 * 对象转换url参数
		 * 遇到属性值为空或0就不拼接
		 */
		objToUrlParam(obj) {
		  let urlParam = '';
		  Object.keys(obj).forEach(function (e) {
		    if (obj[e]) {
		      urlParam += `${e}=${obj[e]}&`
		    }
		  })
		  if (urlParam.length > 0) {
		    urlParam = urlParam.substring(0, urlParam.length - 1);
		  }
		  return urlParam;
		},
		// 给url添加参数 通过对象
		addUrlParamFromObj(url, obj) {
		  if (url.indexOf("?") > -1) {
		    url += "&" + this.objToUrlParam(obj);
		  } else {
		    if (obj && Object.keys(obj).length > 0) {
		      url += "?" + this.objToUrlParam(obj);
		    }
		  }
		  return url;
		},
    handleRecommend(item) {
      // 点击文章
      if (item.urls?.shortUrl) {
				let params = this.getParamFromUrl(location.href)
				delete params.id
				delete params.psn
				let url = item.urls.shortUrl
				let urls_rd = ''
				if (url.indexOf('/rd/') !== -1) {
					urls_rd = url.split('/rd/')[1]
				}
				if (urls_rd) {
					let urls_rd_add = encodeURIComponent(this.addUrlParamFromObj(decodeURIComponent(urls_rd), params))
					url = url.replace(urls_rd, urls_rd_add)
				} else {
					url = this.addUrlParamFromObj(url, params)
				}
        location.href = url;
      }
    },
    handleCollect() {
      // 收藏
      if ((cfg.subdomian == "qmyx" || cfg.subdomian == "ajzl") && !wj.browser.versions.dy) {
        $(".favorite").trigger("tap");
      } else {
        this.isCollect = !this.isCollect;
      }
    },
    handleComplaint() {
      // 投诉
      this.showComplaint = true;
    },
    handleCancel(e) {
      this.showComplaint = false;
    },
    handleSelect(item) {
      this.showComplaint = false;
      this.showComplaintToast = true;
			if (this.step) {
			  clearTimeout(this.step);
			}
			this.step = setTimeout(() => {
			  this.showComplaintToast = false;
			}, 2000);
			let params = {
				contents: item,
				nickname: myTemp?.userIntegralInfo?.userInfo?.user?.name || '',
				openid: myTemp.openid,
				pageid: myPageData.PageId
			}
			if (myTemp.openid) {
				comreq.addComplain(params).then(res => {
					console.log(res)
				})
			}
    },
  },
  created() {
    console.log(myPageData);
    if (myPageData?.Wxstyle) {
      this.wxAccountname = myPageData.Wxaccountname;
    }
    this.initRecommendList();
  },
  mounted() {
    $("#footernew_p").html($("#footernew"));
  },
});
